// form
import { useFormContext, Controller } from 'react-hook-form';
// @mui
import { TextField, TextFieldProps } from '@mui/material';
import * as React from 'react';

// ----------------------------------------------------------------------

interface IProps {
  name: string;
  onAfterChange?: React.ChangeEventHandler<
    HTMLInputElement | HTMLTextAreaElement
  >;
}

export default function RHFTextField({
  name,
  onAfterChange,
  ...other
}: IProps & TextFieldProps) {
  const { control } = useFormContext();

  return (
    <Controller
      name={name}
      control={control}
      render={({ field, fieldState: { error } }) => {
        return (
          <TextField
            {...field}
            fullWidth
            error={!!error}
            helperText={error?.message}
            onWheel={(event) =>
              event.target instanceof HTMLElement && event.target.blur()
            }
            onChange={
              onAfterChange
                ? (event) => {
                    field.onChange(event);
                    onAfterChange(event);
                  }
                : field.onChange
            }
            {...other}
          />
        );
      }}
    />
  );
}
